import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const Logo = ({ size = 'medium' }) => {
  const { isRussian } = useLanguage();
  
  const sizes = {
    small: { icon: 24, text: 14, subtext: 10 },
    medium: { icon: 32, text: 18, subtext: 12 },
    large: { icon: 48, text: 24, subtext: 16 },
  };
  
  const s = sizes[size] || sizes.medium;
  
  return (
    <div className="d-flex align-items-center gap-2">
      {/* Hexagonal Icon */}
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer hexagon */}
        <path
          d="M20 2L36 11V29L20 38L4 29V11L20 2Z"
          fill="#FF6B35"
          stroke="#FF6B35"
          strokeWidth="2"
        />
        {/* Inner warehouse icon */}
        <path
          d="M20 10L28 15V25L20 30L12 25V15L20 10Z"
          fill="white"
          fillOpacity="0.9"
        />
        {/* Box detail */}
        <rect x="17" y="18" width="6" height="6" fill="#FF6B35" />
        <path
          d="M17 18H23M20 18V24"
          stroke="white"
          strokeWidth="1"
        />
      </svg>
      
      {/* Text */}
      <div className="d-flex flex-column lh-1">
        <span
          style={{
            fontSize: s.text,
            fontWeight: 300,
            color: '#666',
            letterSpacing: '0.5px',
          }}
        >
          Indigo
        </span>
        <span
          style={{
            fontSize: s.subtext,
            fontWeight: 700,
            color: '#FF6B35',
            letterSpacing: '1px',
            textTransform: 'uppercase',
          }}
        >
          {isRussian ? 'СКЛАД' : 'WAREHOUSE'}
        </span>
      </div>
    </div>
  );
};

export default Logo;

